jQuery.noConflict();
(function( $ ) {

	$(document).ready(function() {

		// Variables
		const _calcBtn = $('#calculate-advantage-form .calculate-advantage-btn');
		const _calcInputs = $('#calculate-advantage-form .calculate-form-input');
		const _newCalcBtn = $('#new-calculation-button');


		// Calculation slider
		$('#block-calculation').slick({
			rows: 0,
			dots: false,
			arrows: false,
			infinite: true,
			speed: 600,
			fade: false,
			autoplay: false,
			adaptiveHeight: true,
			draggable: false,
			swipe: false
		});

		
		// Disable / Enable button
		$('#calculate-advantage-form .calculate-form-input').on('change keyup', function(e) {
			let valid = true;

			$(_calcInputs).each(function(){
			    if( $(this).val().length === 0 ) {
			    	valid = false;
			    }
			});

			if( valid === true ) {
				$( _calcBtn ).prop("disabled", false);
			} else {
				$( _calcBtn ).prop("disabled", true);
			}
		});


		// Formulas
		const calculateMoreAmbassadors = ( customers ) =>  customers * 0.131;
		const calculateExtraCrossSales = ( customers, policies ) => ( 5 - ( policies / customers ) ) * 0.065 * customers + 0.065 * 0.05 * customers;
		const calculateLessCancellations = ( policies ) => policies * 0.028;
		const calculateMoreCustomerData = ( customers ) => customers * 0.43;
		const calculateLaborSavings = ( customers, policies ) => ( 4.5 * customers + 5 * policies + 0.28 * 5 * customers ) / 60;


		// Helper functions
		const pad2 = ( n ) => (n < 10 ? '0' : '') + n;
		const minusIsZero = ( n ) => (n < 0 ? 0 : n);


		// Main functions
		const setupCalculationHTMLOutput = ( totalCustomers, totalPolicies, callback ) => {

			// Get calculations
			const calculations = {
				moreAmbassadors: Math.ceil( calculateMoreAmbassadors( totalCustomers ) ),
				extraCrossSales: Math.ceil( calculateExtraCrossSales( totalCustomers, totalPolicies ) ), 
				lessCancellations: Math.ceil( calculateLessCancellations( totalPolicies ) ),
				moreCustomerData: Math.ceil( calculateMoreCustomerData( totalCustomers ) ),
				laborSavings: Math.ceil( calculateLaborSavings( totalCustomers, totalPolicies ) )
			};

			// Set output values
			const outputValues = {
				moreAmbassadors: pad2( minusIsZero( calculations.moreAmbassadors ) ),
				extraCrossSales: pad2( minusIsZero( calculations.extraCrossSales ) ), 
				lessCancellations: pad2( minusIsZero( calculations.lessCancellations ) ),
				moreCustomerData: pad2( minusIsZero( calculations.moreCustomerData ) ),
				laborSavings: pad2( minusIsZero( calculations.laborSavings ) )
			};

			// Setup values in html on result page
			const keys = Object.keys(outputValues);

			keys.forEach((key, index) => {		    
			    let spans = "";
			    const items = outputValues[key].split('');
			    items.map( item => spans += '<span>' + item + '</span>' );
			    $('#score-wrap-' + index).html(spans);
			});

			// Callback
			if(callback && typeof(callback) === 'function'){
				callback();
			}

		}

		const clearCalculationInputs = ( callback ) => {
			$( _calcInputs ).val('');
			$( _calcBtn ).prop("disabled", true);

			// Callback
			if(callback && typeof(callback) === 'function'){
				callback();
			}
		}

		const goToInputSlide = () => {
			$('#block-calculation').slick('slickPrev');

			$('html, body').animate({
				scrollTop: $('#calculate-advantage-form').offset().top
			}, 800);
		}

		const goToResultSlide = () => {
			$('#block-calculation').slick('slickNext');

			$('html, body').animate({
				scrollTop: $('#block-calculation').offset().top
			}, 800);
		}


		// Trigger buttons
		$( _calcBtn ).click( (e) => {

			// Get values
			const totalCustomers = parseInt( $('#calculate-advantage-form .total-customers').val() );
			const totalPolicies = parseInt( $('#calculate-advantage-form .total-policies').val() );

			// Setup output html / move to result slide
			setupCalculationHTMLOutput( totalCustomers, totalPolicies, goToResultSlide() );
		});

		$( _newCalcBtn ).click( (e) => {
			clearCalculationInputs( goToInputSlide() );
		} );


	}); // End document.ready
})(jQuery); // End jQuery